/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface Player {
  /** @format string */
  clId: string;

  /** @format number */
  fogisId: number;

  /** @format string */
  esId?: string;

  /** @format string */
  forzasysId?: string;

  /** @format string */
  smcId?: string;

  /** @format string */
  optaId?: string;

  /** @format string */
  givenName: string;

  /** @format string */
  surName: string;

  /** @format string */
  fullName: string;
  displayName?: string;
  nickName?: string;

  /** @format string */
  birthDay?: string;

  /** @format string */
  gender?: 'man' | 'woman';
  height?: number;
  weight?: number;
  number?: number;
  agent?: string;
  nationality?: string;
  images?: Images;

  /** @format string */
  foot?: 'right' | 'left';

  /** @format string */
  youthClub?: string;
  position?: Position;
  socialMedia?: SocialMedia;
  healthStatus?: HealthStatus;
  currentClub?: CurrentClub[];
}

export enum Positions {
  Goalkeeper = 'Goalkeeper',
  CentreBack = 'Centre-Back',
  LeftBack = 'Left-Back',
  RightBack = 'Right-Back',
  Back = 'Back',
  DefensiveMidfield = 'Defensive Midfield',
  CentralMidfield = 'Central Midfield',
  AttackingMidfield = 'Attacking Midfield',
  Midfield = 'Midfield',
  LeftWinger = 'Left Winger',
  RightWinger = 'Right Winger',
  CentreForward = 'Centre Forward',
  Forward = 'Forward',
  AttackingCentralMidfield = 'Attacking Central Midfield',
}

export interface Position {
  /** Primary position */
  primary?:
    | 'Goalkeeper'
    | 'Centre-Back'
    | 'Left-Back'
    | 'Right-Back'
    | 'Back'
    | 'Defensive Midfield'
    | 'Central Midfield'
    | 'Attacking Midfield'
    | 'Midfield'
    | 'Left Winger'
    | 'Right Winger'
    | 'Centre Forward'
    | 'Forward'
    | 'Attacking Central Midfield';

  /** Secondary position */
  other?: (
    | 'Goalkeeper'
    | 'Centre-Back'
    | 'Left-Back'
    | 'Right-Back'
    | 'Back'
    | 'Defensive Midfield'
    | 'Central Midfield'
    | 'Attacking Midfield'
    | 'Midfield'
    | 'Left Winger'
    | 'Right Winger'
    | 'Centre Forward'
    | 'Forward'
    | 'Attacking Central Midfield'
  )[];
}

export interface SocialMedia {
  /** Instagram URL */
  instagram?: string;

  /** Twitter URL */
  twitter?: string;

  /** Facebook URL */
  facebook?: string;
}

export interface HealthStatus {
  injured?: boolean;

  /** Description of injury */
  description?: string;

  /** From date */
  fromDate?: string;

  /** To date */
  toDate?: string;
}

export interface CurrentClub {
  /** Name of club/team. */
  name?: string;

  /** teamId */
  id?: string;

  /** Date when player joined club. */
  joined?: string;

  /** Player has contract until following date. */
  contractUntil?: string;

  /** Type of contract between player and club. */
  contractType?: string;

  /** Active/Inactive */
  active?: boolean;

  /** Number on matchshirt */
  shirtNumber?: number;

  /** Status of player in club. */
  status?: 'onLoan' | 'temporary' | 'regular';
}

export interface PlayerEditedResponse {
  /** HTTP Status */
  status?: 200;
  message?: 'Succesfully updated data in database';
  additionalMessage?: '';
}

export interface PlayerEditedErrorResponse {
  /** HTTP Status */
  status?: 500;
  message?: 'Failed to update data in database';

  /** Possible error-message */
  additionalMessage?: '';
}

export interface PlayerMinimized {
  /** HTTP Status */
  clId: string;
  fogisId: string;
  givenName: string;
  surName: string;
  displayName?: string;
  nickName?: string;
  birthDay?: string;
  images?: Images;
  gender?: 'man' | 'woman';
}

export interface PlayerAssign {
  /** clId of player */
  playerId?: string;

  /** clId of team */
  teamId?: string;

  /** Type of contract between player and club. */
  contractType?: string;

  /** Player has contract until following date. */
  contractUntil?: string;

  /** Date when player joined club. */
  joined?: string;

  /** Squad for which year */
  year?: string;
}

export interface NewSquad {
  teamId?: string;
  year?: string;
  players?: string;
}

export interface Stats {
  /** ConnectedLeague-id */
  clId?: string;
  goals?: number;
  assists?: number;
  points?: number;
  redCards?: number;
  yellowCards?: number;
  gamesPlayed?: number;
  minutesPlayed?: number;
  subins?: number;
  subout?: number;
  goalsInfo?: GoalsInfo;
  cleanSheet?: number;
  goalsConceded?: number;
  id: string;
  fogisId?: string;
  smcId?: number;
  externalLeagueId?: string;
  leagueName: string;
  teamName: string;
  seasonStartYear?: number;
  seasonEndYear?: number;
}

export interface EditStats {
  clId: string;
  statsRow: Stats;
}

export interface GoalsInfo {
  corner?: number;
  freeKick?: number;
  header?: number;
  normal?: number;
  penalty10m?: number;
  penalty?: number;
}

export interface Images {
  fogisImage?: string;
  sefImagePng?: string;
  sefImageJpg?: string;
}

export interface PlayersMinimized {
  players?: PlayerMinimized[];
}
